module.exports = __webpack_public_path__ + "static/img/home_type_icon_jybk.e094891d.webp";